import { RootState } from '../reducers';

export namespace AppSelectors {
	export const getCurrentLocation = (state: RootState) => state.router.location;
	export const getSettings = (state: RootState) => state.app.settings;
	export const getIsFetchingDataState = (state: RootState) => state.app.isFetchingData;
	export const getUserHash = (state: RootState) => state.app.userHash;
}
